"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorFields = exports.ErrorTypeSchema = exports.castToErrorType = exports.ErrorType = exports.castToErrorSeverity = exports.ErrorSeveritySchema = exports.ErrorSeverity = exports.RecordAfterSchema = exports.RecordBeforeSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../core");
const cast_1 = require("../../utils/cast");
exports.RecordBeforeSchema = typebox_1.Type.Optional((0, core_1.JSONObject)({}, {}));
exports.RecordAfterSchema = typebox_1.Type.Optional((0, core_1.JSONObject)({}, {}));
var ErrorSeverity;
(function (ErrorSeverity) {
    ErrorSeverity["LOW"] = "LOW";
    ErrorSeverity["MEDIUM"] = "MEDIUM";
    ErrorSeverity["HIGH"] = "HIGH";
})(ErrorSeverity = exports.ErrorSeverity || (exports.ErrorSeverity = {}));
exports.ErrorSeveritySchema = (0, core_1.StringUnion)([
    ErrorSeverity.LOW,
    ErrorSeverity.MEDIUM,
    ErrorSeverity.HIGH,
]);
exports.castToErrorSeverity = (0, cast_1.castToEnum)(ErrorSeverity);
// Prefix
// e - error (to distinguish from notifications / history)
// 1 - version
var ErrorType;
(function (ErrorType) {
    // General error type
    ErrorType["GENERAL_ERROR"] = "e1.error";
    // Job specific errors
    ErrorType["APPLE_AUTH_JOB_ERROR"] = "e1.apple-auth-job.error";
    ErrorType["BUDGETS_ALLOCATION_JOB_ERROR"] = "e1.budgets-allocation-job.error";
    ErrorType["APPLE_REPLICA_JOB_ERROR"] = "e1.apple-replica-job.error";
    ErrorType["EGRESS_JOB_ERROR"] = "e1.egress-job.error";
    ErrorType["PAYMENTS_INVOICE_JOB_ERROR"] = "e1.payments-invoice-job.error";
    ErrorType["APPLE_CHANNELS_SYNC_JOB_ERROR"] = "e1.apple-channels-sync-job.error";
    ErrorType["APPLE_CHANNELS_SCHEDULED_CHANGES_JOB_ERROR"] = "e1.apple-channels-scheduled-changes-job.error";
    ErrorType["RULES_JOB_ERROR"] = "e1.rules-job.error";
    // Worker specific errors
    ErrorType["APPLE_REPLICA_WORKER_ERROR"] = "e1.apple-replica-worker.error";
    ErrorType["ATTRIBUTION_WORKER_ERROR"] = "e1.attribution-worker.error";
    ErrorType["BUDGET_ALLOCATION_WORKER_ERROR"] = "e1.budgets-allocation-worker.error";
    ErrorType["PAYMENTS_INVOICE_WORKER_ERROR"] = "e1.payments-invoice-worker.error";
    ErrorType["EGRESS_WORKER_ERROR"] = "e1.egress-worker.error";
    ErrorType["INGRESS_BID_WORKER_ERROR"] = "e1.ingress-bid-worker.error";
    ErrorType["APPLE_CHANNELS_SYNC_WORKER_ERROR"] = "e1.apple-channels-sync-worker.error";
    ErrorType["APPLE_CHANNELS_SCHEDULED_CHANGES_WORKER_ERROR"] = "e1.apple-channels-scheduled-changes-worker.error";
    ErrorType["RULES_WORKER_ERROR"] = "e1.rules-worker.error";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
exports.castToErrorType = (0, cast_1.castToEnum)(ErrorType);
exports.ErrorTypeSchema = (0, core_1.StringUnion)([
    ErrorType.GENERAL_ERROR,
    ErrorType.BUDGETS_ALLOCATION_JOB_ERROR,
    ErrorType.APPLE_AUTH_JOB_ERROR,
    ErrorType.APPLE_REPLICA_JOB_ERROR,
    ErrorType.APPLE_AUTH_JOB_ERROR,
    ErrorType.EGRESS_JOB_ERROR,
    ErrorType.PAYMENTS_INVOICE_JOB_ERROR,
    ErrorType.APPLE_REPLICA_WORKER_ERROR,
    ErrorType.ATTRIBUTION_WORKER_ERROR,
    ErrorType.BUDGET_ALLOCATION_WORKER_ERROR,
    ErrorType.PAYMENTS_INVOICE_WORKER_ERROR,
    ErrorType.EGRESS_WORKER_ERROR,
    ErrorType.INGRESS_BID_WORKER_ERROR,
    ErrorType.APPLE_CHANNELS_SYNC_WORKER_ERROR,
    ErrorType.APPLE_CHANNELS_SYNC_JOB_ERROR,
    ErrorType.APPLE_CHANNELS_SCHEDULED_CHANGES_JOB_ERROR,
    ErrorType.RULES_JOB_ERROR,
    ErrorType.APPLE_CHANNELS_SCHEDULED_CHANGES_WORKER_ERROR,
    ErrorType.RULES_WORKER_ERROR,
]);
exports.ErrorFields = {
    type: exports.ErrorTypeSchema,
    timestamp: core_1.TimestampSchema,
    service: typebox_1.Type.String(),
    message: typebox_1.Type.String(),
    severity: exports.ErrorSeveritySchema,
    payload: (0, core_1.JSONObject)({}, {}),
    campaignId: typebox_1.Type.Optional(core_1.IdSchema),
    teamId: typebox_1.Type.Optional(core_1.IdSchema),
    userId: typebox_1.Type.Optional(core_1.IdSchema),
};
